<div class="grid grid-cols-12 my-20">
  <div class="col-start-2 col-span-10 lg:col-start-4 lg:col-span-6">
    <h1 class="self-stretch text-center justify-start text-gray-900 text-4xl font-extrabold font-['Inter'] leading-[54px]">
      Entre em Contato
    </h1>

    <div class="self-stretch justify-start mt-10 text-gray-500 text-base font-normal font-['Inter'] leading-normal">
      <p>
        Estamos aqui para ajudar. Se você tiver dúvidas sobre a plataforma, assinatura, pagamentos, alertas, suporte técnico ou qualquer outro assunto relacionado à Casato Brasil, entre em contato conosco.
      </p>

      <p class="mt-4">
        Responderemos o mais breve possível.
      </p>

      <section class="mt-8">
        <h2 class="font-bold text-gray-900">E-mail de contato:</h2>
        <p class="mt-1">
          <a href="mailto:contato&#64;casatobrasil.com.br" class="text-blue-600 hover:underline">contato&#64;casatobrasil.com.br</a>
        </p>
        <h2 class="mt-4 font-bold text-gray-900">WhatsApp de contato:</h2>
        <p class="mt-1">
          <a href="https://wa.me/5511992448762"
             target="_blank"
             rel="noopener noreferrer"
             class="text-blue-600 hover:underline">
            Fale conosco pelo WhatsApp
          </a>
        </p>
      </section>

      <section class="mt-8">
        <h2 class="font-bold text-gray-900">Horário de Atendimento</h2>
        <p class="mt-1">
          Segunda a sexta-feira, em horário comercial.
        </p>
      </section>

      <section class="mt-8">
        <h2 class="font-bold text-gray-900">Assuntos Comuns</h2>
        <ul class="mt-2 list-disc pl-6 space-y-1">
          <li>Dúvidas sobre assinatura</li>
          <li>Cancelamento ou cobrança</li>
          <li>Problemas de acesso à conta</li>
          <li>Alertas e notificações</li>
          <li>Sugestões e melhorias</li>
          <li>Questões de privacidade e dados pessoais</li>
        </ul>
      </section>

      <section class="mt-8">
        <h2 class="font-bold text-gray-900">Importante</h2>
        <p class="mt-1">
          Para agilizar o atendimento, envie sua mensagem utilizando o e-mail vinculado à sua conta, quando aplicável.
        </p>
      </section>
    </div>
  </div>
</div>
